
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#363636"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M9 10.834h15.006M9 17.834h8M9 24.834h5.002"}}),_c('circle',{attrs:{"cx":"26.886","cy":"26.886","r":"3.126","fill":"#F9B621","stroke":"#494949"}})]),_c('g',{attrs:{"stroke-width":"2"}},[_c('path',{attrs:{"d":"M20.118 26.886h-.735M33.654 26.886h.735M26.886 33.654v.735M26.886 20.118v-.735M22.1 31.671l-.52.521M31.671 22.1l.52-.52M31.671 31.671l.52.521M22.1 22.1l-.52-.52"}})])])
          )
        }
      }
    